export enum ConnectionType {
  pressAccordingToTab = 1,
  weldedConnections = 2,
}
